import { useDispatch, useSelector } from "react-redux";
import { closeModal, OpenModal, setMainLoading, setPageTitle } from "../Store/reducers/Common";
import { useEffect, useState } from "react";
import { PostAxios, responseCatchFunc } from "../Services/RequestService";
import { Link } from "react-router-dom";
import moment from "moment";
import { ConvertErrorArrayToString } from "../Services/Common";
import { setToastData } from "../Store/reducers/Toast";
import Modal from "../Services/Modal";
import { Scanner } from "@yudiel/react-qr-scanner";
import PieChart from "../Services/Charts/PieChart";

const Welcom = () => {
	const dispatch = useDispatch();
	const { userData, accessToken } = useSelector(
		(state) => state.user
	);
	const [eventsList, setEventsList] = useState([]);
	const [surveyList, setSurveyList] = useState([]);
	const [divOffList, setDivOffList] = useState({});
	const [profilePercentage, setProfilePercentage] = useState(0);
	const [qrScannerPopup, openQrScannerPopup] = useState(false);
	useEffect(() => {
		dispatch(setPageTitle(`Dashboard`));
		let promiseArray = [PostAxios(`event/event-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div }, accessToken)];
		if (userData.user_div > 0) {
			promiseArray.push(PostAxios(`users/div-hierarchy`, { div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div }, accessToken))
			promiseArray.push(PostAxios(`survey/pending-surveys`, { org_id: userData.org_id, div_id: userData.user_div }, accessToken))
			promiseArray.push(PostAxios(`users/profile-percentage`, { mem_id: userData.id }, accessToken))
		}
		dispatch(setMainLoading(true));
		Promise.all(promiseArray)
			.then((response) => {
				if (response[0]?.data.status === "1") {
					let eventList = response[0]?.data?.data;
					if (eventList.length > 0) {
						setEventsList(eventList);
					}
				}
				if (typeof response[1] !== "undefined") {
					setDivOffList(response[1].data.data)
				}
				if (typeof response[2] !== "undefined") {
					setSurveyList(response[2].data.list)
				}
				if (typeof response[3] !== "undefined") {
					setProfilePercentage(response[3].data.data)
				}
			})
			.catch(err => {
				responseCatchFunc(dispatch, err);
			})
			.finally(() => {
				dispatch(setMainLoading(false));
			})
	}, [dispatch, accessToken]);
	const markAttendance = (attendanceStatus, userId, userDiv, qr_id) => {
		if (!navigator.onLine) {
			dispatch(setToastData({ message: 'Internet connection is required to mark attendance.', isHtml: true, type: 'error', showCloseBtn: true }));
			return;
		}
		dispatch(setMainLoading(true));
		PostAxios(`event/mark-attendance`, {
			event_id: qr_id,
			mem_id: userId,
			attendance_response: attendanceStatus,
			div_id: userDiv,
			client_online: 1,
		}, accessToken)
			.then(({ data }) => {
				if (data.status === "1") {
					dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
				}
				else {
					dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
				}
			})
			.catch((err) => {
				responseCatchFunc(dispatch, err);
			})
			.finally(() => {
				dispatch(setMainLoading(false));
			})
	}
	return (
		<div className="card-container">
			<div className="card w-25">
				<div className="card-content">
					<h3 className="card-title">Profile Completion</h3>
					<PieChart options={
						{
							title: {
								text: `Profile Completion - ${profilePercentage.percentage || 0}%`,
							},
							series: [
								{
									name: "Profile Completion",
									colorByPoint: true,
									data: [
										{
											name: "Completed",
											y: profilePercentage.completedFields,
											color: "#4caf50", // Green for completed
										},
										{
											name: "Incomplete",
											y: profilePercentage.totalFields - profilePercentage.completedFields,
											color: "#f44336", // Red for incomplete
										},
									],
								},
							]
						}
					} />
				</div>
			</div>
			{
				eventsList.length > 0 &&
				<div className="card w-25">
					<div className="card-content">
						<h3 className="card-title">Upcoming Events</h3>
						{eventsList.length === 0 && <p>No events</p>}
						{
							eventsList.length > 0 &&
							<ul className="list-wrapper">
								{
									eventsList.map((item, index) => {
										let divName = '';
										if (parseInt(item.event_user_div) === 0) {
											divName = 'All';
										}
										else if (item.div_name_list.trim() !== "") {
											let splitDNl = item.div_name_list.split(';');
											for (let i of splitDNl) {
												let splitDn = i.split('|');
												if (parseInt(splitDn[0]) === parseInt(userData.user_div)) {
													divName = splitDn[1];
													break;
												}
												else if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
													if (divName !== "") {
														divName += ', ';
													}
													divName += splitDn[1];
												}
											}
										}
										else if (parseInt(item.event_user_div) === parseInt(userData.user_div)) {
											divName = item.division_name;
										}


										return <li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item.event_title}</span><br />
											<p className="list-content">Division : {divName}</p>
											<p className="list-content">
												{moment(`${item.event_start_date} ${item?.event_start_time}`).format('DD MMM YYYY hh:mm a')}
												&nbsp; - &nbsp;
												{moment(`${item.event_end_date} ${item?.event_end_time}`).format('DD MMM YYYY hh:mm a')}
											</p>
											{
												((moment().isBetween(
													moment(`${item.event_start_date} ${item.event_start_time}`, "YYYY-MM-DD HH:mm"),
													moment(`${item.event_end_date} ${item.event_end_time}`, "YYYY-MM-DD HH:mm"),
													'minute',
													'[]'
												)) &&
												moment().isSameOrAfter(moment(`${moment().format("YYYY-MM-DD")} ${item.event_start_time}`)) &&
												moment().isSameOrBefore(moment(`${moment().format("YYYY-MM-DD")} ${item.attendence_time}`))) &&
												// (moment(`${item.event_start_date} ${item.event_start_time}`) <= moment() && moment(`${item.event_start_date} ${item.attendence_time}`) >= moment()) && 
												<>
													<button type="button" className="btn btn-blue mt-2 d-block text-center" style={{ width: "100%" }} onClick={() => {
														openQrScannerPopup(true);
														dispatch(OpenModal())
													}}><i className="fas fa-camera"></i> &nbsp;Scan QR Code</button>
												</>
											}
											{
												moment(`${item.event_start_date} ${item?.event_start_time}`) <= moment() &&
												<Link to={'events/view'} state={{ event_id: item.id }} className="btn btn-blue mt-2 d-block text-center">View Event</Link>
											}
										</li>
									}
									)
								}
							</ul>
						}
					</div>
				</div>
			}
			{
				userData.role_slug !== "super_admin" &&
				<div className="card w-25">
					<div className="card-content">
						<h3 className="card-title">Division Officers</h3>
						{
							typeof divOffList.captain !== "undefined" &&
							<ul className="list-wrapper">
								{
									divOffList?.sr_asst_cmd.length > 0 && divOffList.sr_asst_cmd.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Sr. Assitant Commander</p>
										</li>
									)
								}
								{
									divOffList?.asst_cmd.length > 0 && divOffList.asst_cmd.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Assitant Commander</p>
										</li>
									)
								}
								{
									divOffList?.major.length > 0 && divOffList.major.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Major</p>
										</li>
									)
								}
								{
									divOffList?.hr_admin.length > 0 && divOffList.hr_admin.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">HR Admin</p>
										</li>
									)
								}
								{
									divOffList?.office_admin.length > 0 && divOffList.office_admin.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Office Admin</p>
										</li>
									)
								}
								{
									divOffList?.captain.length > 0 && divOffList.captain.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Captain</p>
										</li>
									)
								}
								{
									divOffList?.vice_captain.length > 0 && divOffList.vice_captain.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Vice Captain</p>
										</li>
									)
								}
								{
									divOffList?.grp_leader.length > 0 && divOffList.grp_leader.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Group Leader</p>
										</li>
									)
								}
								{
									divOffList?.ass_grp_leader.length > 0 && divOffList.ass_grp_leader.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Assistant Group Leader</p>
										</li>
									)
								}
								{
									divOffList?.div_admin.length > 0 && divOffList.div_admin.map((item, index) =>
										<li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item?.user_title_prefix} {item?.first_name} Bhai {item?.last_name}</span>
											<p className="list-content">Division Admin</p>
										</li>
									)
								}
							</ul>
						}
					</div>
				</div>
			}
			{
				userData.role_slug !== "super_admin" && surveyList.length > 0 &&
				<div className="card w-25">
					<div className="card-content">
						<h3 className="card-title">Survey</h3>
						{surveyList.length === 0 && <p>No Pending Survey</p>}
						{
							surveyList.length > 0 &&
							<ul className="list-wrapper">
								{
									surveyList.map((item, index) => {
										return <li className="list-item" key={`event-index-${index}`}>
											<span className="list-title">{item.title}</span><br />
											<p className="list-content">{item.description.substring(0, 100)}...</p>
											<Link to={'survey/fill-survey'} state={{ survey_id: item.id }} className="btn btn-blue mt-2 d-block text-center">Submit Survey</Link>
										</li>
									}
									)
								}
							</ul>
						}
					</div>
				</div>
			}
			{
				qrScannerPopup === true && <Modal classList="popup-main invoice-popup" style={{ maxWidth: 400, minHeight: 500, width: '100%' }} onClose={() => {
					openQrScannerPopup(false);
				}}>
					<Scanner onScan={(result) => {
						dispatch(closeModal())
						openQrScannerPopup(false);
						markAttendance(1, userData.id, userData.user_div, result[0].rawValue);
					}} />
				</Modal>
			}
		</div>
	)
}

export default Welcom;